// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__cXeRJ","modal__content":"Modal_modal__content__vrtHG","active":"Modal_active__M+wdP"};